import { render, staticRenderFns } from "./_base-page-header.vue?vue&type=template&id=c51dc3e4&scoped=true&"
import script from "./_base-page-header.vue?vue&type=script&lang=js&"
export * from "./_base-page-header.vue?vue&type=script&lang=js&"
import style0 from "./_base-page-header.vue?vue&type=style&index=0&id=c51dc3e4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51dc3e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c51dc3e4')) {
      api.createRecord('c51dc3e4', component.options)
    } else {
      api.reload('c51dc3e4', component.options)
    }
    module.hot.accept("./_base-page-header.vue?vue&type=template&id=c51dc3e4&scoped=true&", function () {
      api.rerender('c51dc3e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base-page-header.vue"
export default component.exports